import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Constants } from 'src/app/Constants';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { map, shareReplay } from 'rxjs/operators';
import * as moment from 'moment';
import { PlatformService } from '../platformbase.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  modalInst=[];
  i=0;
  scriptfile: HTMLScriptElement;
  private showHeaderMobile = new BehaviorSubject<boolean>(true);
  showHeaderMobile$ = this.showHeaderMobile.asObservable();
  rawHttp: HttpClient;
  private cachedAppTheme: any = null;
  private appThemeRequest$: Observable<any>;
  private restrictTextFieldSpecialChars = false;
  private textFieldAllowedPunctuation: string[] = ['.', ',', '|', '(', ')', '-', '_', ':', "'", '&', '/'];

  constructor(
    public httpClient: HttpClient,
    private httpBackend: HttpBackend,
    private platformService: PlatformService
  ) {
    this.rawHttp = new HttpClient(this.httpBackend);
    this.getAppTheme().subscribe(() => {}, () => {});
  }

  getSingleLegalEntity(requestBody): Observable<any> {
    const url = Constants.BASE_URL + "v1/legal-entity/get";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  fileUpload(requestBody): Observable<any> {
    const url = Constants.BASE_URL + "v1/file-upload/upload";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getAllLegalEntities(requestBody): Observable<any> {
    const url = Constants.BASE_URL + "v1/legal-entity/list";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }
  getCategorylist(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/category/list";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }
  getCatgryMasterlist(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/recurrent/category/master/list";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getMerchantlist(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/merchant/list";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getMerchantlistByCategory(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/merchant/list-by-category";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getCurrencylist(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/currency/list";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  statusList(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/common/status";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }
  fliterList(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/trip-details/filter";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }
  getpolicyList(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/policy/for-user";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getViolations(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/policy/policy-check";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getUsers(requestBody: any): Observable<any> {
    const url = Constants.BASE_URL + "v1/user-managment/list";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getForUserPolicyCatpolicyList(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/policy/for-user-category";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getCategoryRule(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/recurrent/category/rule/check";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

   downloadList(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/bulk-jobs/export";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  downloadCardsList(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/bulk-jobs/export/card/report";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  downloadTripsList(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/bulk-jobs/download-trips";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }
  
  downloadAnalyticsAll(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/bulk-jobs/export-analytics";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }
  downloadActiveUserSummary(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/bulk-jobs/active-user-summary";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  downloadpoolStart(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/bulk-jobs/pool";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getStates(requestBody): Observable<any>{
    const url = Constants.BASE_URL + "v1/common/state/list";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }
  getCountries(requestBody): Observable<any> {
    const url = Constants.BASE_URL + "v1/common/country/list";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }
  getCities(requestBody): Observable<any> {
    const url = "https://uat.api.eva.travel/v1/common/cities";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getCommonLookup(requestBody): Observable<any>{
    const url = Constants.BASE_URL + "v1/common-lookup/get";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getDistanceFromMapMyIndia(requestBody): Observable<any>{
    const url = Constants.DOMAIN_URL + "v1/mapmyindia/getDistance";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }
  getUserPreferance(requestBody): Observable<any>{
    const url = Constants.DOMAIN_URL + "v1/user-preference/get";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }
  saveUserPreferance(requestBody): Observable<any>{
    const url = Constants.DOMAIN_URL + "v1/user-preference/save";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }
  getCompanyConfigurations(requestBody): Observable<any>{
    const url = Constants.DOMAIN_URL + "v1/user-preference/get-company-configurations";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  fetchAndStoreCompanyConfigurations(userInfo: any): void {
    if (!userInfo?.companyId || !(userInfo?.companyGuId || userInfo?.companyGUID)) {
      return;
    }
    const requestObj = {
      companyId: userInfo.companyId,
      companyGUID: userInfo.companyGuId || userInfo.companyGUID,
      userDevice: this.platformService.isMobileDevice() ? 'mobile' : 'web'
    };
    this.getCompanyConfigurations(requestObj).subscribe((res: any) => {
      if (!res?.isError && res?.errorCode === 0) {
        localStorage.setItem(
          'companyCustomAttributes',
          JSON.stringify(res?.payload?.companyCustomAttributes || [])
        );
      }
    }, () => {
      // Keep existing local attributes if config fetch fails.
    });
  }


  bulkFinancePayment(requestBody): Observable<any>{
    const url = Constants.DOMAIN_URL + "/v1/finance-payment/bulk-finance-payment";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  // Mobile FC-365
 
  getExpenseOverviewData(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/analytics/year-data-365";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getSystemFieldsList(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/company-fields/system-fields/list";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }
  getUserFieldsList(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/company-fields/custom-fields/list";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  saveSystemFields(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/company-fields/system-fields/save";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }
  saveCustomFields(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/company-fields/custom-fields/save";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getFieldsInfo(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/company-fields/fields-info";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getClaimFieldsInfo(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/company-fields/claim-fields-info";
    return this.httpClient.post(url, requestBody);
  }

  getForeignExchnage(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/currency-exchange/foreign-exchange-rates";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getExchangeRateOnDate(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "v1/currency-exchange/exchangeRateOnDate";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getUserManagerList(requestBody: any): Observable<any> {
    const url = Constants.BASE_URL + "v1/user-managment/list";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getCardUsersList(requestBody: any): Observable<any> {
    const url = Constants.BASE_URL + "v1/user-managment/card-users-list";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  getMobileAppVersion(requestBody): any {
    const url = environment.eva_auth + 'authentication/v1/mobile-version';
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  storeModal(x)
  {
        this.modalInst[this.i]=x;
        this.i++;
  }

  // Setter method to update the value
  setShowHeaderMobile(value: boolean): void {
    this.showHeaderMobile.next(value);
  }

  async downloadPdfUrl(url:any) {
    var errorCode = 1;
      /*
    if (url == "" || url== null) {
    } else {
        let target = "_system";
        let options: InAppBrowserOptions = {
          location: 'yes',
          hidden: 'no',
          clearcache: 'yes',
          clearsessioncache: 'yes',
          zoom: 'yes',
          hardwareback: 'yes',
          mediaPlaybackRequiresUserAction: 'no',
          shouldPauseOnSuspend: 'no',
          closebuttoncaption: 'Close',
          disallowoverscroll: 'no',
          toolbar: 'yes',
          enableViewportScale: 'no',
          allowInlineMediaPlayback: 'no',
          presentationstyle: 'pagesheet',
          fullscreen: 'yes'
      };

        this.pdfDownloadCall.create(url, target, options);
        errorCode = 0;
    }
 */
    return errorCode;

 }

 public googlescriptAdd(){
  this.scriptfile = document.createElement('script');
  let googlekey;
  let user = JSON.parse(sessionStorage.getItem("userInfo"));
  if (user) googlekey = user.googleKey; // "AIzaSyBzSd9D55dnMezjUNfoqelAplxaPkHn8q0" //user.googleKey;
  // this.scriptfile.src = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + googlekey;
  this.scriptfile.type = 'text/javascript';
  this.scriptfile.async = true;
  this.scriptfile.charset = 'utf-8';
  this.scriptfile.id = 'googleAutoComplete';
    let googleautoComplete = document.getElementById('googleAutoComplete') as HTMLScriptElement;
    if(!googleautoComplete){
      document.getElementsByTagName('body')[0].appendChild(this.scriptfile);
    } else{
      googleautoComplete.src = this.scriptfile.src;
    }
}

getCustomReport(requestBody: any): Observable<any> {
  const url = Constants.DOMAIN_URL + "/v1/ai-booking-report-data-parsing";
  const body = requestBody;
  return this.httpClient.post(url, body);
}

getCardList(requestBody: any): Observable<any> {
  const url = Constants.DOMAIN_URL + "v1/common/common-lookup";
  const body = requestBody;
  return this.httpClient.post(url, body);
}

encryptData(data: string): string {
  let key = environment.EncryptionKey;
  var keys = CryptoJS.enc.Utf8.parse(key);
  var iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(
      data,
      keys,
      {
          iv: iv,
          padding: CryptoJS.pad.Pkcs7,
          mode: CryptoJS.mode.CBC
      }
  );

  return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
}

  isIconPresent(icon) {
    const iconList = [
      "fa-btc",
      "fa-eur",
      "fa-gg-circle",
      "fa-krw",
      "fa-rub",
      "fa-ils",
      "fa-viacoin",
      "fa-money",
      "fa-try",
      "fa-jpy",
      "fa-gbp",
      "fa-inr",
      "fa-usd",
      "fa-gg"
    ];

    return iconList.includes(icon);
  }

  clickHouseView(type, view) {
    const reportActions = {
      my: {
        cards: "NE_MY_EXPENSE_DASHBOARD",
        bar: "NE_MY_EXPENSE_BARCHART",
        pie: "NE_MY_EXPENSE_PIECHART",
      },
      team: {
        cards: "NE_TEAM_EXPENSE_DASHBOARD",
        bar: "NE_TEAM_EXPENSE_BARCHART",
        pie: "NE_TEAM_EXPENSE_PIECHART",
      },
      company: {
        cards: "NE_COMPANY_EXPENSE_DASHBOARD",
        bar: "NE_COMPANY_EXPENSE_BARCHART",
        pie: "NE_COMPANY_EXPENSE_PIECHART",
      },
    };
    return reportActions[type]?.[view] || "";
  }

  clickHouseViewTrips(type) {
    const reportActions = {
      claimed: "NE_CLAIMED_TRIPS",
      inProgress: "NE_INPROGRESS_TRIPS",
      unclaimed: "NE_UNCLAIMED_TRIPS",
      tripsPopup: "NE_UNCLAIMED_TRIPS_FOR_POPUP"
    };
    return reportActions[type] || "";
  }

  clickHouseViewCards(type) {
    const reportActions = {
      claimed: "NE_CLAIMED_CARDS",
      unclaimed: "NE_UNCLAIMED_CARDS",
    };
    return reportActions[type] || "";
  }

  clickHouseViewClaims(type) {
    const reportActions = {
      summary: "NE_EXPENSE_SUMMARY_ON_CLAIM_LIST"
    };
    return reportActions[type] || "";
  }

  checkRestriction(type, msg) {
    if(sessionStorage.getItem('restriction')){
      let restriction = JSON.parse(sessionStorage.getItem('restriction'));
      return { isRestricted: restriction[type], msg: restriction[msg] };
    } else {
      return null;
    }
  }

  logoutAPI(requestBody: any): Observable<any> {
    const url = Constants.DOMAIN_URL + "/v1/authentication/user-logout";
    const body = requestBody;
    return this.httpClient.post(url, body);
  }

  downloadFile(fileUrl: string) {
    const fileName = fileUrl.split('/').pop() || 'downloaded-file';
  
    this.rawHttp.get(fileUrl, { responseType: 'blob' }).subscribe(blob => {
      const link = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      link.href = objectUrl;
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(objectUrl);
    });
  }

  getAppTheme(): Observable<any> {
    if (this.cachedAppTheme) {
      return of(this.cachedAppTheme);
    }
    if (!this.appThemeRequest$) {
      this.appThemeRequest$ = this.httpClient.get<any[]>('./assets/theme-config.json').pipe(
        map(data => {
          const currentUrl = window.location.href.toLowerCase();
          const matchedConfig = data.find(config => currentUrl.includes(config.contains_url));
          this.cachedAppTheme = matchedConfig ? matchedConfig : data[0];
          this.applyTextFieldCharConfig(this.cachedAppTheme);
          return this.cachedAppTheme;
        }),
        shareReplay(1)
      );
    }
    return this.appThemeRequest$;
  }

  isTextFieldSpecialCharRestrictEnabled(): boolean {
    return this.restrictTextFieldSpecialChars;
  }

  sanitizeTextFieldValue(value: string): string {
    if (value == null || value === '') {
      return value || '';
    }
    const escaped = (this.textFieldAllowedPunctuation || []).map(ch => String(ch).replace(/[\\^\]-]/g, '\\$&')).join('');
    const regex = new RegExp(`[^a-zA-Z0-9\\s${escaped}]`, 'g');
    return String(value).replace(regex, '').replace(/^\s+/, '');
  }

  private applyTextFieldCharConfig(config: any) {
    if (!config) {
      return;
    }
    this.restrictTextFieldSpecialChars = config.restrictTextFieldSpecialChars === true;
    if (Array.isArray(config.textFieldAllowedPunctuation)) {
      this.textFieldAllowedPunctuation = config.textFieldAllowedPunctuation;
    }
  }

  // Date Format
  dateFormatAPI(date) {
    if (!moment.utc(date, 'DD-MM-YYYY', true).isValid() || moment.isMoment(date) || this.checkDateFormat(date)) {
      return moment(date).format('DD-MM-YYYY');
    } else {
      return date;
    }
  }
  checkDateFormat(date) {
    let cleanedDate = date?.toString().replace(/\(.*\)/, '').trim();
    return (!moment.utc(cleanedDate, 'DD-MM-YYYY', true).isValid() && !moment(cleanedDate, 'ddd MMM DD YYYY HH:mm:ss ZZ', true).isValid())
  }
  // Date Format

  isAdminView() {
    try {
      const isAdminStr = sessionStorage.getItem('isadmin');
      return isAdminStr && isAdminStr !== 'undefined' ? JSON.parse(isAdminStr) : false;
    } catch (e) {
      return false;
    }
  }

  convertToDD_MM_YYYY(date: any): string {
    // Handle null/undefined/empty cases
    if (!date || date === '') {
      return '';
    }

    try {
      // Handle moment objects
      if (moment.isMoment(date)) {
        return date.format('DD-MM-YYYY');
      }

      // Handle timestamps (numbers)
      if (typeof date === 'number') {
        const dateObj = new Date(date);
        const day = ('0' + dateObj.getUTCDate()).slice(-2);
        const month = ('0' + (dateObj.getUTCMonth() + 1)).slice(-2);
        const year = dateObj.getUTCFullYear();
        return `${day}-${month}-${year}`;
      }

      // Handle Date objects
      if (date instanceof Date) {
        if (isNaN(date.getTime())) {
          return '';
        }
        
        const isoString = date.toISOString();
        if (isoString.includes('T00:00:00.000Z')) {
          const day = ('0' + date.getUTCDate()).slice(-2);
          const month = ('0' + (date.getUTCMonth() + 1)).slice(-2);
          const year = date.getUTCFullYear();
          return `${day}-${month}-${year}`;
        } else {
          const day = ('0' + date.getDate()).slice(-2);
          const month = ('0' + (date.getMonth() + 1)).slice(-2);
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        }
      }

      // Handle string inputs
      if (typeof date === 'string') {
        const dateStr = date.trim();
        
        // For ISO strings with Z, extract directly
        if (dateStr.includes('T') && dateStr.includes('Z')) {
          const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
          if (match) {
            return `${match[3]}-${match[2]}-${match[1]}`;
          }
        }
        
        // ISO format YYYY-MM-DD or YYYY/MM/DD
        let match = dateStr.match(/^(\d{4})[-\/](\d{1,2})[-\/](\d{1,2})/);
        if (match) {
          const year = match[1];
          const month = ('0' + match[2]).slice(-2);
          const day = ('0' + match[3]).slice(-2);
          return `${day}-${month}-${year}`;
        }
        
        // Handle DD-MM-YYYY or MM-DD-YYYY format
        if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
          const parts = dateStr.split('-');
          const first = parseInt(parts[0], 10);
          const second = parseInt(parts[1], 10);
          const year = parts[2];
          
          // Unambiguous cases
          if (first > 12 && second <= 12) {
            // Definitely DD-MM-YYYY (e.g., 15-08-2025)
            return dateStr;
          } else if (first <= 12 && second > 12) {
            // Definitely MM-DD-YYYY (e.g., 08-15-2025), needs conversion
            return `${parts[1]}-${parts[0]}-${parts[2]}`;
          } else if (first <= 12 && second <= 12) {
            // Ambiguous case - both could be valid
            // Use a heuristic: if the date makes more sense in US format context
            
            // Special handling for specific test cases
            // '08-04-2025' is likely MM-DD-YYYY (August 4, 2025)
            // '04-08-2025' is likely DD-MM-YYYY (4 August 2025)
            
            // Heuristic: If first number is 01-12 and second is 01-31,
            // and we're parsing a US-style date, assume MM-DD-YYYY
            // Otherwise assume DD-MM-YYYY
            
            // Check if it's more likely to be US format
            // US format typically has month (01-12) first
            // If first number is 08 and second is 04, it's likely US format (Aug 4)
            // If first number is 04 and second is 08, it's likely DD-MM format (4 Aug)
            
            // Create both possible dates and see which makes more sense
            const asDD_MM = moment(`${parts[0]}-${parts[1]}-${parts[2]}`, 'DD-MM-YYYY', true);
            const asMM_DD = moment(`${parts[0]}-${parts[1]}-${parts[2]}`, 'MM-DD-YYYY', true);
            
            // If only one is valid, use that
            if (asDD_MM.isValid() && !asMM_DD.isValid()) {
              return dateStr;
            } else if (!asDD_MM.isValid() && asMM_DD.isValid()) {
              return `${parts[1]}-${parts[0]}-${parts[2]}`;
            }
            
            // Both are valid - use context clues
            // Pattern recognition: MM-DD-YYYY often has months 01-12 in first position
            // DD-MM-YYYY often has days 01-31 in first position
            
            // For ambiguous cases, prefer DD-MM-YYYY format (Indian/European standard)
            // This ensures dates like '08-04-2025' are treated as 8th April (DD-MM-YYYY)
            // rather than August 4th (MM-DD-YYYY)
            
            // Default: assume it's already in DD-MM-YYYY format
            return dateStr;
          }
        }
        
        // Handle slash format
        if (dateStr.includes('/')) {
          const parts = dateStr.split('/');
          if (parts.length === 3) {
            const first = parseInt(parts[0], 10);
            const second = parseInt(parts[1], 10);
            const year = parts[2];
            
            if (first > 12 && second <= 12) {
              const day = ('0' + first).slice(-2);
              const month = ('0' + second).slice(-2);
              return `${day}-${month}-${year}`;
            } else if (first <= 12 && second > 12) {
              const day = ('0' + second).slice(-2);
              const month = ('0' + first).slice(-2);
              return `${day}-${month}-${year}`;
            } else {
              // Ambiguous for slash format - default to DD/MM/YYYY
              const day = ('0' + first).slice(-2);
              const month = ('0' + second).slice(-2);
              return `${day}-${month}-${year}`;
            }
          }
        }
        
        // Use moment for complex formats
        // Try US format FIRST for explicit US format strings
        const formats = [
          'MM-DD-YYYY',    // US format
          'MM/DD/YYYY',    
          'DD-MM-YYYY',    
          'DD/MM/YYYY',    
          'YYYY-MM-DD',
          'YYYY/MM/DD',
          'DD MMM YYYY',
          'DD MMMM YYYY',
          'MMM DD, YYYY',
          'MMMM DD, YYYY',
          'MMMM D, YYYY',
          'D MMMM YYYY',
          'D MMM YYYY'
        ];

        for (const format of formats) {
          const momentDate = moment(dateStr, format, true);
          if (momentDate.isValid()) {
            return momentDate.format('DD-MM-YYYY');
          }
        }
        
        // Last resort
        const momentDate = moment(dateStr);
        if (momentDate.isValid()) {
          return momentDate.format('DD-MM-YYYY');
        }
      }

      console.warn('Could not parse date:', date);
      return '';

    } catch (error) {
      console.error('Error converting date:', error, date);
      return '';
    }
  }
}
